import { Reveal, Eyebrow } from "./Reveal";

const STEPS = [
  {
    time: "10:42 AM",
    title: "A call goes unanswered",
    text: "A homeowner calls your business line. You're under a sink with both hands full. It rings out.",
  },
  {
    time: "10:43 AM",
    title: "The text goes out",
    text: "The caller gets a text from your business within about a minute.",
    bubble: {
      from: "Your business",
      body: "Sorry I missed your call — what can I do for you?",
      mine: true,
    },
  },
  {
    time: "10:43 AM",
    title: "Your phone buzzes",
    text: "You get an alert at the same time, with the caller's number. You reply from the app when you've got a hand free.",
  },
  {
    time: "10:51 AM",
    title: "The customer replies",
    bubble: {
      from: "The customer",
      body: "Furnace quit last night. Any chance someone can come today?",
      mine: false,
    },
  },
  {
    time: "11:15 AM",
    title: "You call back and book it",
    text: "On your break you call a real person with a real job, and put it in the schedule. The next guy on Google never hears about it.",
  },
];

export const Sequence = () => (
  <section id="how-it-works" className="border-t-2 border-line" data-testid="sequence-section">
    <div className="mx-auto max-w-6xl px-4 py-20 sm:px-6 sm:py-28">
      <Reveal>
        <Eyebrow>How it works</Eyebrow>
        <h2 className="mt-4 max-w-3xl font-display text-3xl font-bold uppercase leading-none tracking-tight sm:text-4xl md:text-5xl">
          From missed call to booked job
        </h2>
        <p className="mt-4 inline-block border-2 border-safety px-3 py-2 font-mono text-xs uppercase tracking-[0.2em] text-safety">
          An example — made-up names, realistic times
        </p>
      </Reveal>
      <div className="mt-14" data-testid="sequence-timeline">
        {STEPS.map((step, i) => (
          <Reveal key={`${step.time}-${step.title}`} delay={i * 0.05}>
            <div className="relative border-l-2 border-line pb-12 pl-8 last:pb-0 sm:pl-12">
              <span className="absolute -left-[7px] top-1 h-3 w-3 rotate-45 bg-safety" aria-hidden="true" />
              <p className="font-mono text-sm font-semibold uppercase tracking-[0.2em] text-safety">
                {step.time}
              </p>
              <h3 className="mt-2 font-display text-xl font-bold uppercase tracking-tight sm:text-2xl">
                {step.title}
              </h3>
              {step.text && (
                <p className="mt-2 max-w-2xl text-base leading-relaxed text-gray-300 sm:text-lg">
                  {step.text}
                </p>
              )}
              {step.bubble && (
                <div
                  className={`mt-4 max-w-md border-2 p-4 sm:p-5 ${
                    step.bubble.mine ? "border-safety bg-[#161300]" : "border-line bg-surface"
                  }`}
                >
                  <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-smoke">
                    {step.bubble.mine ? "Text from your business" : step.bubble.from}
                  </p>
                  <p className="mt-2 text-base font-medium leading-relaxed sm:text-lg">
                    {step.bubble.body}
                  </p>
                </div>
              )}
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal className="mt-16">
        <div className="hazard-strip h-2 w-full" aria-hidden="true" />
        <div className="border-2 border-line border-t-0 bg-surface p-6 sm:p-10">
          <h3 className="font-display text-2xl font-bold uppercase tracking-tight text-safety sm:text-3xl">
            Nobody talks to your customers
          </h3>
          <p className="mt-4 max-w-3xl text-base leading-relaxed text-gray-300 sm:text-xl">
            No robot picks up your phone. No stranger in a call centre. The caller gets one plain
            text from your business — the same text you'd send yourself, except it goes out in
            about a minute instead of at nine at night. The wording is yours, and so is the
            conversation.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
